import Vue from "vue";
import moment from "moment";
// import "moment-timezone";
// var idLocale = require("moment/locale/id");

moment.locale("id");

Vue.filter("formatDt2", function (value) {
  if (
    value === "0000-00-00" ||
    value === null ||
    value === "none" ||
    value === "0000-00-00 00:00:00" ||
    value === "-" ||
    value === ""
  ) {
    return "-";
  } else {
    return moment(value).format("DD/MM/Y");
  }
});
Vue.filter("formatDt3", function (value) {
  if (
    value === "0000-00-00" ||
    value === null ||
    value === "none" ||
    value === "0000-00-00 00:00:00" ||
    value === "-" ||
    value === ""
  ) {
    return "-";
  } else {
    return moment(value).format("DD-MM-Y");
  }
});
Vue.filter("formatDt4", function (value) {
  if (
    value === "0000-00-00" ||
    value === null ||
    value === "none" ||
    value === "0000-00-00 00:00:00" ||
    value === "-" ||
    value === ""
  ) {
    return "-";
  } else {
    return moment(value).format("DD/MM/Y HH:mm:ss");
  }
});
Vue.filter("formatDt5", function (value) {
  if (
    value === "0000-00-00" ||
    value === null ||
    value === "none" ||
    value === "0000-00-00 00:00:00" ||
    value === "-" ||
    value === ""
  ) {
    return "-";
  } else {
    if (/^\d{8} \d{2}:\d{2}:\d{2}$/.test(value)) {
      return moment(value, "YYYYMMDD HH:mm:ss").format("DD/MM/Y HH:mm:ss");
    }
    return moment(value).format("DD/MM/Y HH:mm:ss");
  }
});
